import { TimelineMax, TweenMax } from "gsap";
import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import Layer from '../../../vendor_core/core/src/utils/Layer';
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import Utils from "../../../vendor_core/core/src/utils/Utils";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import TextField from "../../../vendor_core/core/src/views/components/TextField";
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import BBMultiplierController from '../controllers/BBMultiplierController';
import BBModel from "../model/BBModel";
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBReelGroup from "../view/BBReelGroup";
import BBReelSymbol from '../view/BBSymbol';

export default class BBCascadeState extends State {
    public destroySymbolTimes = {
        background: 0.2,
        trembling: 0.02,
    }
    public enter(): void {
        super.enter();
        // let newTime = new Date().getTime();

        // if (BBModel.spinStartTime !== 0) {
        //     ConsoleUtil.red(`Total spin time: ${(newTime - BBModel.spinStartTime) / 1000}`);
        // }

        // BBModel.spinStartTime = newTime;
        BBModel.resetFromToVerbsArrays();
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;
        // Clear win lines and info
        // reelGroup.hideLinesAndInfo(true);
        // Prepare the popped finish handler
        // App.dispatcher.once(GameEvents.ALL_SYMBOLS_POPPED, this.exit, this);
        if (SpinModel.getCurrentSpinProperty("cascadeExplodesOffsets")?.length > 1) {
            // if (true) {
            if (BBModel.allowFakeScreenShakeTrigger <= 2) {
                BBModel.allowFakeScreenShakeTrigger += 1;
            }
            BBModel.hasExplode = true;
            let DESymbolPosition = { x: 0, y: 0 }
            if (BBModel.cascades[SpinModel.cascadeIndex]) {
                BBModel.cascades[SpinModel.cascadeIndex].symbols.forEach((reel, i) => {
                    reel.forEach((symbol, j) => {
                        if (symbol == "DE") {
                            DESymbolPosition = { x: i, y: j }
                        }
                    });
                })
            }
            const DESymbol = reelGroup.reels[DESymbolPosition.x].symbols[DESymbolPosition.y] as BBReelSymbol;
            const wilds = reelGroup.searchWilds();
            const nonBlacking = wilds.map(wild => ({
                reelIndex: wild.x,
                cellIndex: wild.y
            }));
            nonBlacking.push({ reelIndex: DESymbolPosition.x, cellIndex: DESymbolPosition.y })
            // const DESymbol = reelGroup.reels[5].symbols[5];

            let destroySymbolsTimeline = new TimelineMax({ paused: false })
            UIController.setState(UIStates.STOP_SPIN)
            destroySymbolsTimeline.add(() => BBAnimationsHelper.playBGNightAnim(), 0)
            destroySymbolsTimeline.add(() => { BBAnimationsHelper.playThunderLogoAnim() }, 0)
            destroySymbolsTimeline.add(() => { BBAnimationsHelper.blackingSymbols(reelGroup, nonBlacking) }, 0.5)
            destroySymbolsTimeline.add(() => { reelGroup.DESymbolAnimation(DESymbol) }, 0.5)
            destroySymbolsTimeline.add(() => { BBAnimationsHelper.playThunderBolt(DESymbol) }, 2)
            destroySymbolsTimeline.add(() => { reelGroup.DESymbolAnimationPop(DESymbol) }, 2.2)
            destroySymbolsTimeline.add(() => reelGroup.popSymbols(SpinModel.getCurrentCascadeExplodeMap()), 2.5)
            destroySymbolsTimeline.add(() => { BBAnimationsHelper.unBlackingSymbols(reelGroup, nonBlacking) }, 2.6)
            destroySymbolsTimeline.add(() => {
                BBAnimationsHelper.playBGMainAnim();
                ConsoleUtil.green("dispatch from thunder");
                this.exit()
                // App.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED)
            }, 3)
            // destroySymbolsTimeline.add(TweenMax.delayedCall(0.33, () => {
            //     BBAnimationsHelper.playBGMainAnim();
            //     ConsoleUtil.green("dispatch from thunder");
            //     this.exit()
            //     // App.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED)
            // }), 2)
            // destroySymbolsTimeline.add(() => { reelGroup.popSymbols(SpinModel.getCurrentCascadeExplodeMap()) }, 1)
        } else {
            reelGroup.popSymbols(SpinModel.getCurrentCascadeExplodeMap());
            SoundController.playSound(SoundVars.EFFECT_SYMBOLPOP);
            // TweenMax.delayedCall(0.2, () => App.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED))
            TweenMax.delayedCall(0.33, () => {
                ConsoleUtil.green("dispatch out of thunder");
                this.exit()
                // App.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED)
            })
        }
        BBMultiplierController.playMultiplierAnim();
        // BBAnimationsHelper.playMultiplierAnim();
    }
}
